import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBookmarkRemove: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBookmarkRemove"><Path d="M20 7.77455L22.6966 6.78797L23.212 8.19666L1.30334 16.212L0.787964 14.8033L3.99999 13.6282V2H20V7.77455Z" fill="currentColor"/><Path d="M3.99999 22.5204V16.8227L20 10.969V22.5204L12 18.1066L3.99999 22.5204Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBookmarkRemove;
